import Controller from "./dispatchers.controller";
import template from "./dispatchers.html";

const dispatchers = {
  template,
  controller: Controller,
};

export default dispatchers;



// WEBPACK FOOTER //
// ./src/pages/dispatchers/dispatchers.component.js